const firebaseConfig = {
    apiKey: "AIzaSyDSHILhMbCuEJbyajoozKiOrY1_1SpZeqY",
    authDomain: "doctor-portal-726bb.firebaseapp.com",
    projectId: "doctor-portal-726bb",
    storageBucket: "doctor-portal-726bb.appspot.com",
    messagingSenderId: "980487047346",
    appId: "1:980487047346:web:35c1bd5ab86d09fe7f61ab"
  };

  export default firebaseConfig;